export default "__VITE_ASSET__xV4zIlJx__"